import { createSelector } from '@ngrx/store';

import { onlineMenuFiltersState } from '../root';

export const getOnlineMenuFiltersLocationNo = createSelector(onlineMenuFiltersState, (onlineMenuFilters) => onlineMenuFilters?.locationNo || null);
